import { formatPhoneDisplay, isPhoneComplete, normalizePhone } from "./phoneUtils";

const normalizePhoneEntry = (entry) => {
  const normalized = normalizePhone(entry);
  return {
    type: entry?.type?.trim() || "mobile",
    countryCode: normalized.countryCode,
    areaCode: normalized.areaCode,
    number: normalized.number,
    isDefault: Boolean(entry?.isDefault),
    tags: Array.isArray(entry?.tags) ? entry.tags : [],
  };
};

const normalizeEmailEntry = (entry) => ({
  type: entry?.type?.trim() || "personal",
  value: entry?.value?.trim() ?? "",
  isDefault: Boolean(entry?.isDefault),
  tags: Array.isArray(entry?.tags) ? entry.tags : [],
});

export const hydrateClientContacts = (client) => {
  if (!client || typeof client !== "object") return client;

  const next = { ...client };
  const phones = Array.isArray(next.phones) ? [...next.phones] : [];
  const emails = Array.isArray(next.emails) ? [...next.emails] : [];

  if (phones.length === 0) {
    if (isPhoneComplete(next.phone)) {
      phones.push(
        normalizePhoneEntry({
          type: "mobile",
          ...normalizePhone(next.phone),
          isDefault: true,
        })
      );
    }
    if (isPhoneComplete(next.phone2)) {
      phones.push(
        normalizePhoneEntry({
          type: "other",
          ...normalizePhone(next.phone2),
          isDefault: phones.length === 0,
        })
      );
    }
  }

  if (emails.length === 0 && next.email?.trim()) {
    emails.push(
      normalizeEmailEntry({
        type: "personal",
        value: next.email,
        isDefault: true,
      })
    );
  }

  next.phones = phones.filter((entry) => isPhoneComplete(entry));
  next.emails = emails.filter((entry) => entry.value?.trim());

  if (next.phones.length && !next.phones.some((phone) => phone.isDefault)) {
    next.phones[0].isDefault = true;
  }
  if (next.emails.length && !next.emails.some((email) => email.isDefault)) {
    next.emails[0].isDefault = true;
  }

  return next;
};

export const getDefaultPhone = (client) => {
  if (!client) return null;
  const hydrated = hydrateClientContacts(client);
  const fromArray =
    hydrated.phones?.find((phone) => phone?.isDefault) ?? hydrated.phones?.[0];
  if (fromArray && isPhoneComplete(fromArray)) {
    return normalizePhone(fromArray);
  }
  if (isPhoneComplete(hydrated.phone)) {
    return normalizePhone(hydrated.phone);
  }
  return null;
};

export const getDefaultEmail = (client) => {
  if (!client) return "";
  const hydrated = hydrateClientContacts(client);
  const fromArray =
    hydrated.emails?.find((email) => email?.isDefault) ?? hydrated.emails?.[0];
  if (fromArray?.value?.trim()) return fromArray.value.trim();
  return hydrated.email?.trim() ?? "";
};

export const formatDefaultPhoneDisplay = (client) => {
  const phone = getDefaultPhone(client);
  return phone ? formatPhoneDisplay(phone) : "";
};
